import { render, staticRenderFns } from "./ProcessesIndex.vue?vue&type=template&id=2f208ef9"
import script from "./ProcessesIndex.vue?vue&type=script&lang=js"
export * from "./ProcessesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports